function Title({ children }) {

  return (
    <h1
      className="
	        text-3xl
          sm:text-4xl
	        font-extrabold
	        mb-2
	        text-slate-950
      "
    >
      {children}
    </h1>
  );
}

export default Title;
